export default "__VITE_ASSET__DH3KVu1c__"